import React from "react";
import Style from "./ChangeFactorTable.module.css";
import { Table } from "antd";
import "../../Pages/ManageCustomer/ManageCustomer.css";
import { Pencil } from "react-bootstrap-icons";
const ChangeFactorTable = ({ btnHandler, data }) => {
  const columns = [
    {
      title: "نام",
      dataIndex: "name",
      key: "name",
      width: "25%",
      render: (text, record) =>
      record.available==="1"?
      <p >{text} </p>
      :
      <p style={{textDecoration:"line-through"}}>{text} عدد </p>
    },
    {
      title: "تعداد",
      dataIndex: "newCount",
      key: "newCount",
      width: "25%",
      render: (text, record) =>
      record.available==="1"?
      <p >{text} عدد </p>
      :
      <p style={{textDecoration:"line-through"}}>ناموجود</p>
    },
    {
      title: "قیمت",
      dataIndex: "newPrice",
      key: "newPrice",
      width: "25%",
      render: (text, record) =>
      record.available==="1"?
      <p >{text} تومان </p>
      :
      <p style={{textDecoration:"line-through"}}>{text} تومان </p>
    },
    {
      title: "عملیات",
      dataIndex: "orderBtn",
      key: "orderBtn",
      width: "30%",
      render: (text, record) =>
        record.available ==="1"? (
          <div className={Style.btnHolder}>
            <button
              onClick={() => btnHandler(1, record)}
              className={Style.change}
            >
              <Pencil /> مشخصه
            </button>
            <button
              onClick={() => btnHandler(2, record)}
              className={Style.changeProduct}
            >
              <Pencil /> محصول
            </button>
          </div>
        ) : (
          <div className={Style.btnHolder}>
            <button
              onClick={() => btnHandler(1, record)}
              className={Style.changeDisable}
            >
              <Pencil /> مشخصه
            </button>
            <button
              onClick={() => btnHandler(2, record)}
              className={Style.changeProductDisable}
            >
              <Pencil /> محصول
            </button>
          </div>
        ),
    },
  ];
  return (
    <div className={Style.table}>
      <Table
        pagination={false}
        columns={columns}
        size={"middle"}
        dataSource={data && data}
        responsive={true}
        loading={data === undefined ? true : false}
      />
    </div>
  );
};

export default ChangeFactorTable;
